import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationService } from '../../libraries/auth/authorization.service';
import { BasePageComponent } from '../../libraries/base/page/base-page.component';
import { BannerListComponent } from './list/banner-list.component';
import { BannerCreateComponent } from './create/banner-create.component';
import { BannerUpdateComponent } from './update/banner-update.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: BasePageComponent,
        children: [
          {
            path: '',
            component: BannerListComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'banner.read'
            }
          }
        ]
      },
      {
        path: 'create',
        component: BasePageComponent,
        data: {
          breadcrumb: 'Add Banner'
        },
        children: [
          {
            path: '',
            component: BannerCreateComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'banner.create'
            }
          }
        ]
      },
      {
        path: ':id/update',
        component: BasePageComponent,
        data: {
          breadcrumb: 'Update Banner'
        },
        children: [
          {
            path: '',
            component: BannerUpdateComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'banner.update'
            }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BannerRoutingModule {}
